/*
 * Which location a client books at is always one they have seen (GUARDRAILS
 * G49, DECISIONS D28). The link `/select-location` opens the location picker
 * with nothing ticked, whatever this phone remembers, and the picker tags the
 * remembered location "Last visited".
 */

/** The link a salon shares (Google profile, a sign) to have the client pick first. */
export const SELECT_LOCATION_PATH = '/select-location';

/** True on the link's address (a trailing slash too). */
export const isSelectLocationPath = (pathname: string | null | undefined): boolean =>
  (pathname || '').replace(/\/+$/, '').toLowerCase() === SELECT_LOCATION_PATH;

/** The id of the location this phone remembers (`selectedStore`), or null. */
export const rememberedStoreId = (raw?: string | null): number | null => {
  let text = raw;
  if (text === undefined) {
    try {
      text = localStorage.getItem('selectedStore');
    } catch {
      return null;
    }
  }
  if (!text) return null;
  try {
    const id = Number(JSON.parse(text)?.id);
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
};
